import React from "react";
import {
  Grid,
  Box,
  Typography,
  ThemeProvider,
  TextField,
  LinearProgress,
  CircularProgress,
  Divider,
  IconButton,
  List,
  Alert,
  Modal,
  Drawer,
  Chip,
  Avatar,
  Skeleton,
  Button,
  useMediaQuery,
} from "@mui/material";

function TechWorthRedirectAds() {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <>
      {!isMobile && (
        <Grid container sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              padding: "20px",
              backgroundColor: "rgba(43,179,68,15%)",
              borderRadius: "15px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundImage:
                "linear-gradient(to right, rgba(43,179,68,10%), rgba(43,179,68,50%) )",
              transition: "transform 0.3s",
              "&:hover": {
                transform: "scale(1.02)",
              },
            }}
          >
            <Grid item xs={12} md={8} lg={12} xl={6}>
              <Box
                sx={{
                  gap: 4,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      color: "#2BB344",
                      fontFamily: "poppins",
                      fontWeight: 700,
                    }}
                    variant="h2"
                  >
                    Are you underpaid?
                  </Typography>
                  <Typography variant="subtitle2">
                    Determine your potential salary by calculating TechWorth
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <Button
                    sx={{
                      color: "#FFF",
                      px: "26px",
                      fontSize: isMobile ? "16px" : "18px",
                      fontWeight: 600,
                      borderRadius: "55px",
                      textAlign: "center",
                      textTransform: "capitalize",
                      background: "#2BB344",
                      backgroundColor: "#2BB344",
                      border: "1px solid #2BB344",
                      transition: "all 0.3s linear",
                      "&:hover": {
                        color: "#2BB344",
                        background: "#fff",
                        border: "1px solid #2BB344",
                        transition: "all 0.3s linear",
                      },
                    }}
                    size={"small"}
                    component={"a"}
                    href={"https://www.worthysalary.trueselfy.com/"}
                  >
                    Check TechWorth
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={4} lg={12} xl={6}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  flexDirection: "column",
                }}
              >
                <img
                  style={{
                    maxWidth: "290px",
                    height: "auto",
                    width: "100%",
                  }}
                  alt="under-paid"
                  src="../../assets/images/under-paid.png"
                />
              </Box>
            </Grid>
          </Box>
        </Grid>
      )}
      {isMobile && (
        <Grid container>
          <Box
            sx={{
              padding: "20px",
              backgroundColor: "rgba(43,179,68,15%)",
              borderRadius: "15px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundImage:
                "linear-gradient(to right, rgba(43,179,68,10%), rgba(43,179,68,50%) )",
              transition: "transform 0.3s",
              "&:hover": {
                transform: "scale(1.02)",
              },
              flexDirection: "column",
            }}
          >
            <Grid item xs={12} md={4} lg={12} xl={6}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  flexDirection: "column",
                }}
              >
                <img
                  style={{
                    maxWidth: "290px",
                    height: "auto",
                    width: "100%",
                  }}
                  alt="under-paid"
                  src="../../assets/images/under-paid.png"
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={8} lg={12} xl={6}>
              <Box
                sx={{
                  gap: 4,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      color: "#2BB344",
                      fontFamily: "poppins",
                      fontWeight: 700,
                    }}
                    variant="h2"
                  >
                    Are you underpaid?
                  </Typography>
                  <Typography variant="subtitle2">
                    Determine your potential salary by calculating TechWorth
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    sx={{
                      color: "#FFF",
                      px: "26px",
                      fontSize: isMobile ? "16px" : "18px",
                      fontWeight: 600,
                      borderRadius: "55px",
                      textAlign: "center",
                      textTransform: "capitalize",
                      background: "#2BB344",
                      backgroundColor: "#2BB344",
                      border: "1px solid #2BB344",
                      transition: "all 0.3s linear",
                      "&:hover": {
                        color: "#2BB344",
                        background: "#fff",
                        border: "1px solid #2BB344",
                        transition: "all 0.3s linear",
                      },
                    }}
                    size={"small"}
                    component={"a"}
                    href={"https://www.worthysalary.trueselfy.com/"}
                  >
                    Check TechWorth
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Box>
        </Grid>
      )}
    </>
  );
}

export default TechWorthRedirectAds;
